import { useQuery } from '@tanstack/react-query';
import { getContactCategories } from '../api/contactCategories';

export function useContactCategories() {
  return useQuery({
    queryKey: ['settings-contact-categories'],
    queryFn: getContactCategories,
  });
}
